import React from 'react';

const UploadIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
            <path d="M4.5 2.66669V6.00002H27.8333V2.66669H4.5ZM4.5 19.3334H11.1667V29.3334H21.1667V19.3334H27.8333L16.1667 7.66669L4.5 19.3334Z" fill="#C9C5C0" />
        </svg>
    )
}

export default UploadIcon;